import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const SITE_URL = 'https://www.smakglod.com';

const KNOWN_PATHS = ['/', '/menu', '/about', '/contact'];

const PAGE_SEO = {
  '/': {
    no: { title: 'Smakglød Torp | Pizza & Grill - Bestill online', description: 'Pizza og grill i Torp. Bestill online for henting eller levering. Burger, pizza, kebab. Åpent 13:30-22:00.' },
    en: { title: 'Smakglød Torp | Pizza & Grill - Order online', description: 'Pizza and grill in Torp. Order online for pickup or delivery. Burgers, pizza, kebab. Open 13:30-22:00.' },
  },
  '/menu': {
    no: { title: 'Meny | Smakglød Torp - Pizza, Burger, Kebab', description: 'Utforsk vår meny med pizza, burger, kebab og mer. Bestill enkelt online.' },
    en: { title: 'Menu | Smakglød Torp - Pizza, Burgers, Kebab', description: 'Explore our menu with pizza, burgers, kebab and more. Order easily online.' },
  },
  '/about': {
    no: { title: 'Om oss | Smakglød Torp', description: 'Lær oss bedre kjent. Smakglød Torp - Pizza og grill med kvalitet og hjerte.' },
    en: { title: 'About us | Smakglød Torp', description: 'Get to know us. Smakglød Torp - Pizza and grill with quality and heart.' },
  },
  '/contact': {
    no: { title: 'Kontakt | Smakglød Torp - Adresse, telefon', description: 'Kontakt Smakglød Torp. Roald Amundsens vei 201 A, 1658 Torp. Ring 94 46 79 22.' },
    en: { title: 'Contact | Smakglød Torp - Address, phone', description: 'Contact Smakglød Torp. Roald Amundsens vei 201 A, 1658 Torp. Call 94 46 79 22.' },
  },
  '404': {
    no: { title: 'Siden finnes ikke | Smakglød Torp', description: 'Siden du leter etter finnes ikke. Gå tilbake til forsiden.' },
    en: { title: 'Page not found | Smakglød Torp', description: 'The page you are looking for does not exist. Go back to the home page.' },
  },
};

function getSEO(pathname, language) {
  const is404 = !KNOWN_PATHS.includes(pathname);
  const seo = is404 ? PAGE_SEO['404'] : (PAGE_SEO[pathname] || PAGE_SEO['/']);
  return seo[language] || seo.no;
}

export function SEO() {
  const { pathname } = useLocation();
  const { language } = useLanguage();
  const { title, description } = getSEO(pathname, language);

  useEffect(() => {
    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', `${SITE_URL}${pathname}`);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}${pathname}`);
  }, [pathname, language, title, description]);

  return null;
}
